import SettingsPage from './SettingsPage'
export default SettingsPage
export * from './SettingsPage'
